import { useMemo } from 'react';

import { PermissionKeys } from 'src/auth/types';
import { useAuthContext } from 'src/auth/hooks';
import { useUserPermissions } from 'src/hooks/use-user-permissions';
import type { UnallocatePermissionGate } from 'src/utils/activity-unallocate-permission';

export function useUnallocatePermissionGate(): UnallocatePermissionGate {
  const { user } = useAuthContext();
  const { hasAnyPermission } = useUserPermissions();

  return useMemo(() => {
    const canDeleteAny = hasAnyPermission([
      { permission: PermissionKeys.DELETE_APPOINTMENTS, levels: ['GROUP', 'ALL'] },
    ]);
    const canDeleteOwn = hasAnyPermission([
      {
        permission: PermissionKeys.DELETE_APPOINTMENTS,
        levels: ['ACTIVITIES_UNDER_MY_PROJECTS', 'OWN'],
      },
    ]);

    return {
      canDeleteAny,
      canDeleteOwn,
      userId: user?.id,
    };
  }, [hasAnyPermission, user?.id]);
}
